<template>
  <div class="border border-[#EFF2F5] rounded-xl pb-6">
    <div class="px-6 pt-6 space-y-2">
      <CPreloader width="150px" height="40px" loading />
      <CPreloader width="150px" height="30px" loading />
    </div>
    <CPreloader width="100%" height="160px" loading preloader-class="mt-5" />
  </div>
</template>

<script setup lang="ts">
import CPreloader from "@/components/CPreloader.vue";
</script>

<style scoped></style>
